import { Avatar, Card, Col, Divider, Row, Show, Space, Tag, Typography } from '@pankod/refine-antd';
import { useShow } from '@pankod/refine-core';
import defaultAvatar from 'assets/images/default-avatar.jpg';
import { AddressShow, PageHeader, PaymentMethodsTable } from 'components';
import { PointOfContactTable } from 'components/point-of-contact';
import { IClient } from 'interfaces';

const { Title, Text } = Typography;

export const ClientShow = () => {
  const { queryResult } = useShow<IClient>({
    metaData: {
      fields: [
        'id',
        'name',
        'email',
        'clientCode',
        'mobileNumber',
        {
          address: ['street', 'area', 'city', 'country', 'zip'],
        },
        {
          clientPhoto: [
            {
              avatar: ['url', 'thumbUrl'],
            },
          ],
        },
        {
          clientTags: [
            {
              tag: ['id', 'name'],
            },
          ],
        },
      ],
    },
  });
  const { data, isLoading: isClientLoading } = queryResult;
  const record = data?.data;
  const clientPhoto = record?.clientPhoto;
  const clientTags = record?.clientTags || [];
  let avatarURL;
  if (clientPhoto instanceof Array) {
    avatarURL = clientPhoto[clientPhoto?.length - 1]?.avatar?.url;
  }

  const tags = clientTags.map((tagObj) => (
    <Tag key={tagObj.tag.id} color="default">
      {tagObj.tag.name}
    </Tag>
  ));

  return (
    <>
      <Show headerProps={{ extra: <PageHeader path="/clients" /> }}>
        <Row gutter={[48, 32]} wrap>
          <Col xs={{ span: 24, order: 2 }} lg={{ span: 17, order: 1 }}>
            <Card loading={isClientLoading} title="Information">
              <Title level={5}>Name</Title>
              <Text>{record?.name}</Text>
              <Title level={5}>Email</Title>
              <Text>{record?.email}</Text>
              <Title level={5}>Mobile Number</Title>
              <Text>{record?.mobileNumber}</Text>
              <Title level={5}>Supplier Code</Title>
              <Text>{record?.clientCode}</Text>
              <Title level={5}>Tags</Title>
              <div style={{ marginBottom: '1.3rem' }}>{tags}</div>
            </Card>
            <Card loading={isClientLoading} title="Address" style={{ marginTop: '32px' }}>
              <AddressShow
                street={record?.address?.street}
                area={record?.address?.area}
                city={record?.address?.city}
                country={record?.address?.country}
                zip={record?.address?.zip}
              />
            </Card>
          </Col>

          <Col xs={{ span: 24, order: 1 }} lg={{ span: 7, order: 2 }}>
            <Card
              style={{
                backgroundColor: '#FAFAFA',
                opacity: 1,
              }}
              bodyStyle={{ height: '300px' }}
            >
              <Space
                direction="vertical"
                align="center"
                style={{
                  width: '100%',
                  textAlign: 'center',
                  margin: '26px 0 30px 0',
                }}
              >
                <Avatar
                  src={isClientLoading ? defaultAvatar : avatarURL ? avatarURL : defaultAvatar}
                  size={200}
                  style={{ objectFit: 'cover' }}
                  alt={`Avatar`}
                />
              </Space>
            </Card>
          </Col>
        </Row>
      </Show>

      <Divider />
      {/* point of contacts table */}
      <Row wrap={false}>
        <Col flex="auto">
          {record?.id && <PointOfContactTable resource="client" resourceId={record?.id} />}
        </Col>
      </Row>

      <Divider />
      {/* payments methods */}
      <Row wrap={false}>
        <Col flex="auto">
          {record?.id && <PaymentMethodsTable resource="client" resourceId={record?.id} />}
        </Col>
      </Row>
    </>
  );
};
